import { FetchWrapper } from "../_models/types";
const api = `${process.env.REACT_APP_API_URL}/v1/`;

const makeFacilitator = async (payload: {}, fetchWrapper: FetchWrapper) => fetchWrapper.post(`${api}user_change_role/`, payload);

export const apiService = {
    makeFacilitator
}
